<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="empty"
    :class="
      cn(
        'flex h-full min-h-60 w-full min-w-0 flex-1 flex-col items-center justify-center text-center font-sans',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
